"use client";

import Image from "next/image";
import Link from "next/link";
import { useTheme } from "@/components/ui/theme-provider";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

export default function NotFound() {
  const { theme } = useTheme();
  const logoSrc = theme === 'light' ? '/images/logos/logo-light.svg' : '/images/logos/logo-dark.png';

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 dark:bg-gray-900 bg-white">
      {/* Logo */}
      <div className="relative h-12 w-[8.5rem] mb-12">
        <Image
          src={logoSrc}
          alt="strivelabs logo"
          fill
          className="object-contain"
          priority
        />
      </div>

      {/* 404 Text */}
      <h1 className="text-9xl font-bold text-gray-900 dark:text-white mb-4">404</h1>
      
      {/* Message */}
      <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-4 text-center">
        Oops! Page not found
      </h2>
      <p className="text-gray-600 dark:text-gray-400 mb-8 text-center max-w-md">
        The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
      </p>

      {/* Return Home Button */}
      <Link href="/">
        <Button 
          className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white"
          size="lg"
        >
          <Home className="w-4 h-4" />
          Return to Home
        </Button>
      </Link>
    </div>
  );
}